import { PageErrorBoundary } from '@/components/PageErrorBoundary'
import { PopulationPage } from './PopulationPage'
import { usePopulationHealthAccess } from './usePopulationHealthAccess'

/**
 * `/population`, behind the `populationHealth` flag. Renders nothing until LaunchDarkly has
 * identified the user, and says so rather than redirecting when the flag is off — a flag that
 * arrives a moment late then simply shows the page instead of having bounced the user away.
 */
export function PopulationRoute() {
  const access = usePopulationHealthAccess()
  if (access === undefined) return null
  if (!access) {
    return (
      <div className="p-6">
        <h1 className="text-2xl font-semibold">Population Health</h1>
        <p className="mt-2 text-sm text-gray-600">
          Population Health isn’t enabled for your account.
        </p>
      </div>
    )
  }
  return (
    <PageErrorBoundary feature="population">
      <PopulationPage />
    </PageErrorBoundary>
  )
}
